<template>
  <!-- Router -->
  <router-view />
</template>
